(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/campaign/assets/internal/shared/utils.js') >= 0) return;  svs.modules.push('/components/numbergames/campaign/assets/internal/shared/utils.js');

'use strict';

let productMapping;
let DRAW_TYPE;
function getCampaignProductFormat(product) {
  return productMapping.getProductDrawId(productMapping.getProductId(product));
}
function getCampaignProducts() {
  return [getCampaignProductFormat(productMapping.CONSTANTS.KENO), getCampaignProductFormat(productMapping.CONSTANTS.LOTTO)];
}
function getValidProduct(product) {
  const validProducts = getCampaignProducts();
  const validProduct = getCampaignProductFormat(product);
  if (validProducts.includes(validProduct)) {
    return validProduct;
  }
}
function getValidDrawTypesByProduct(product) {
  const validDrawTypes = {
    lotto: [DRAW_TYPE.REGULAR, DRAW_TYPE.PERIODIC],
    keno: [DRAW_TYPE.CAMPAIGN]
  };
  return validDrawTypes[product];
}
function isValidNumber(number) {
  return Number.isFinite(Number(number)) && !isNaN(parseInt(number, 10));
}
function getValidYear(_ref) {
  let {
    year,
    date
  } = _ref;
  if (date) {
    year = new Date(date).getFullYear();
  }
  if (isValidNumber(year) && year.toString().length === 4) {
    return year;
  }
}
function getValidMonth(_ref2) {
  let {
    month,
    date
  } = _ref2;
  if (date) {
    month = new Date(date).getMonth() + 1;
  } else {
    month = parseInt(month, 10);
  }
  if (isValidNumber(month) && month >= 1 && month <= 12) {
    return month;
  }
}
const utils = {
  getCampaignProducts,
  getValidProduct,
  getValidDrawTypesByProduct,
  getValidYear,
  getValidMonth
};
if (svs.isServer) {
  const path = require('path');
  const trinidad = require('@svenskaspelab/trinidad-core').core;
  ({
    productMapping
  } = trinidad.components.require('numbergames', 'product-mapping'));
  ({
    DRAW_TYPE
  } = require(path.join(__dirname, '../../constants.es6')));
  module.exports = utils;
} else {
  ({
    productMapping
  } = svs.numbergames);
  ({
    DRAW_TYPE
  } = svs.numbergames.campaign.CONSTANTS);
  svs.numbergames.campaign.internal.utils = utils;
}

 })(window);